// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkspaceCardFooter-module__footerContainer--nQ7n_{display:flex;justify-content:space-between;width:100%}.WorkspaceCardFooter-module__fields--XnvZI{display:flex;width:100%}@media(max-width: 1080px){.WorkspaceCardFooter-module__fields--XnvZI{overflow-x:scroll}.WorkspaceCardFooter-module__fields--XnvZI.WorkspaceCardFooter-module__custom-scrollbar--SwVDj{margin-bottom:-15px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerContainer": `WorkspaceCardFooter-module__footerContainer--nQ7n_`,
	"fields": `WorkspaceCardFooter-module__fields--XnvZI`,
	"custom-scrollbar": `WorkspaceCardFooter-module__custom-scrollbar--SwVDj`
};
module.exports = ___CSS_LOADER_EXPORT___;
